import api from 'api';

export const ORDER_GUIDE_ASYNC_UPDATE_SUCCESS = 'ORDER_GUIDE_ASYNC_UPDATE_SUCCESS';
export const ORDER_GUIDE_RESET_STATE = 'ORDER_GUIDE_RESET_STATE';
export const SET_LOADING_ORDER_GUIDE_STATUS = 'SET_LOADING_ORDER_GUIDE_STATUS';
export const UPDATE_ORDER_GUIDE_PRICE = 'UPDATE_ORDER_GUIDE_PRICE';

function setLoadingOrderGuideStatus(isLoading) {
  return {
    type: SET_LOADING_ORDER_GUIDE_STATUS,
    isLoading,
  };
}

function orderGuideAsyncUpdateSuccess(data) {
  return {
    type: ORDER_GUIDE_ASYNC_UPDATE_SUCCESS,
    data,
  };
}

function updateOrderGuidePrice(data) {
  return {
    type: UPDATE_ORDER_GUIDE_PRICE,
    data,
  };
}

export function resetOrderGuideState() {
  return {
    type: ORDER_GUIDE_RESET_STATE,
  };
}

export function getOrderGuide() {
  return (dispatch, getState) => {
    dispatch(setLoadingOrderGuideStatus(true));
    return api.request('orderGuide/product/list', 'get')
    .then((data) => {
      dispatch(orderGuideAsyncUpdateSuccess(data));
      dispatch(setLoadingOrderGuideStatus(false));
    })
    .catch(() => {
      dispatch(setLoadingOrderGuideStatus(false));
      dispatch(orderGuideAsyncUpdateSuccess({
        firstRecNum: 0,
        lastRecNum: 0,
        totalNumRecs: 0,
        products: [],
        opcoCustomerDate: '',
        loading: false,
      }));
    });
  };
}


export function fetchOrderGuidePrice(orderGuideList) {
  return (dispatch, getState) => {
    
    const args = orderGuideList.map(orderGuide => {
      return {
        supc: orderGuide.supc,
        isSoldAs_split: orderGuide.isSoldAs_split,
      };
    });
    return api.request('price', 'post', args).then((data) => {
      const orderGuidePrices = data.map(orderGuidePrice => {
        return {
          supc: orderGuidePrice.supc,
          unitCost: orderGuidePrice.price,
          priceLoaded: true,
          priceLoadSuccess: true,
        };
      });
      dispatch(updateOrderGuidePrice(orderGuidePrices));
    }).catch(() => {
      const orderGuidePrices = orderGuideList.map(orderGuide => {
        return {
          supc: orderGuide.supc,
          priceLoaded: true,
          priceLoadSuccess: false,
        };
      });
      dispatch(updateOrderGuidePrice(orderGuidePrices));
    });
  };
}
